import React from 'react';
const tones = {
  blue:   'bg-brand-50 text-brand-700',
  green:  'bg-emerald-50 text-emerald-700',
  red:    'bg-red-50 text-red-700',
  amber:  'bg-amber-50 text-amber-700',
  gray:   'bg-ink-100 text-ink-700',
  violet: 'bg-violet-50 text-violet-700',
};
const Badge = ({ tone='gray', className='', children }) => (
  <span className={`badge ${tones[tone] || tones.gray} ${className}`}>{children}</span>
);
export default Badge;
